import AdvancedSEOHead from "@/components/seo/AdvancedSEOHead";
import { pageSEO, absoluteUrl } from "@/lib/seo";

export default function IA() {
  return (
    <>
      <AdvancedSEOHead
        title={pageSEO.ia.title}
        description={pageSEO.ia.description}
        canonical={pageSEO.ia.canonical}
        ogImage="/og/ia-1200x630.jpg"
        ogType="article"
        keywords={pageSEO.ia.keywords}
        breadcrumbs={[
          { name: "IA", url: "/ia" }
        ]}
      />
      
      <main className="min-h-screen">
        <section className="container mx-auto px-4 py-20">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              IA pour Amazon
            </h1>
            <p className="text-xl text-muted-foreground mb-12">
              Solutions d'Intelligence Artificielle pour maximiser vos performances Amazon
            </p>
          </div>
        </section>
      </main>
    </>
  );
}